<form style="padding: 25px">
  <div class="flex flex-col xl:flex-row gap-2 justify-between">
    <span class="flex justify-start items-center text-black font-black uppercase"> Atestados </span>
    <div class="flex justify-start lg:justify-end flex-wrap gap-2">
      <select
        class="w-60 form-select form-select-lg mr-5 text-white font-medium bg-blumine"
        aria-label=".form-select-lg"
        [formControl]="ordenarControl"
      >
        <option disabled>Ordenar</option>
        <option *ngFor="let order of opcoesOrdenacao" [value]="order.value">{{ order.label }}</option>
      </select>

      <div>
        <input [formControl]="acaoInput" type="text" class="form-input w-56" placeholder="Pesquise por Colaborador" />
      </div>
      <div class="flex justify-between">
        <button title="Filtrar Atestados" (click)="filtrarAtestados()" class="px-5 min-w-max btn btn--secondary h-35 ml-5">
          <img class="w-6 h-6" src="./assets/icons/search_white.svg" alt="search" />
        </button>
        <button
          title="Limpar Filtro"
          (click)="limparFiltros()"
          title="Limpar Filtros"
          class="px-5 min-w-max btn btn--primary h-35 ml-5 bg-blumine"
        >
          <img class="w-6 h-6" src="./assets/icons/backspace_white.svg" alt="search" />
        </button>
      </div>

      <!-- <div class="grid grid-flow-col gap-6">
        <button
          class="px-5 btn btn--primary h-35 ml-5 bg-blumine"
          (click)="downloadExcel()"
          title="Download Excel com Atestado"
        >
          <img class="w-6 h-6" src="./assets/icons/download.svg" alt="Download Excel" />
        </button>
      </div> -->
    </div>
  </div>

  <app-list-atestados
    [atestados]="atestados"
    [dadosPaginacao]="dadosPaginacao"
    (mudouPagina)="mudouPagina($event)"
    (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
    (recarregarListagem)="carregarAtestados()"
  ></app-list-atestados>

  <hr class="mb-8" />
  <app-add-new-atestado
    (salvarAtestados)="salvarAtestado.emit()"
    (recarregarListagem)="carregarAtestados()"
  ></app-add-new-atestado>
  <hr class="my-8" *isAllowed="[ERoleAdminString.Doctor, 'sicknote.create']"/>
</form>
